export default __webpack_public_path__ + "assets/9db0d2908e4181263fd75363ea26baad.png";